<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2023. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: settings.vue
  - Created by: ChanYing
  - Create Date: 2023-05-11 17:11
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" id="settings">
    <path
        d="M10 13.75C12.0711 13.75 13.75 12.0711 13.75 10C13.75 7.92893 12.0711 6.25 10 6.25C7.92893 6.25 6.25 7.92893 6.25 10C6.25 12.0711 7.92893 13.75 10 13.75Z"
        :stroke="strokeColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path
        d="M15.4219 6.30469C15.6099 6.57396 15.7746 6.85886 15.914 7.15625L17.9375 8.28125C18.1901 9.41287 18.1928 10.586 17.9453 11.7187L15.914 12.8437C15.7746 13.1411 15.6099 13.426 15.4219 13.6953L15.4609 16.0156C14.6034 16.7971 13.5884 17.3858 12.4844 17.7422L10.4922 16.5469C10.1645 16.5703 9.8355 16.5703 9.5078 16.5469L7.52342 17.7344C6.41585 17.3845 5.39756 16.798 4.53905 16.0156L4.57811 13.7031C4.3916 13.4301 4.22702 13.1428 4.08592 12.8437L2.06248 11.7187C1.80983 10.5871 1.80716 9.41401 2.05467 8.28125L4.08592 7.15625C4.22536 6.85886 4.39003 6.57396 4.57811 6.30469L4.53905 3.98437C5.39659 3.20294 6.41153 2.61422 7.51561 2.25781L9.5078 3.45312C9.8355 3.42968 10.1645 3.42968 10.4922 3.45312L12.4765 2.26563C13.5841 2.61554 14.6024 3.20199 15.4609 3.98437L15.4219 6.30469Z"
        :stroke="strokeColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: "settings-svg",
  props: {
    strokeColor: {
      type: String,
      default: "var(--body-aux-1)"
    }
  },
}
</script>

